/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Use_NavigationInputs */



/**
* | output |
* | --- |
* | "Use the navigation menu to find what you need" |
*
* @param {Notfound_Use_NavigationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notfound_use_navigation = /** @type {((inputs?: Notfound_Use_NavigationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Use_NavigationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwende das Navigationsmenü, um zu finden, was du brauchst")
	return /** @type {LocalizedString} */ ("Use the navigation menu to find what you need")
});